import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import BusinessPoolAccountsFilters from './BusinessPoolAccountsFilters';
import BusinessPoolAccountsTable from './BusinessPoolAccountsTable';
import usePoolAccountList from './usePoolAccountList';

/**
 * Pool accounts: the accounts a merchant funds its own wallet through.
 *
 * Extracted from this screen's `index.tsx` when Accounts became tabbed (Pool /
 * Settlement); the body is unchanged apart from the `Header`, which now lives
 * on the tab shell so it renders once above both tabs.
 */
const PoolAccountsTab = () => {
  const {
    isLoading,
    fetchList,
    pageInfo,
    list,
    isPageReset,
    isSearch,
    selectCurrentFilters,
    currentFilters,
    handleAutoComplete,
    clearFilters,
  } = usePoolAccountList();

  return (
    <>
      <BusinessPoolAccountsFilters
        handleAutoComplete={handleAutoComplete}
        currentFilters={currentFilters}
        selectCurrentFilters={selectCurrentFilters}
        clearFilters={clearFilters}
      />

      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <BusinessPoolAccountsTable items={list} />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </>
  );
};

export default PoolAccountsTab;
